<div class="e-context-dropdown">
    <button class="e-menu-button drop-btn" aria-controls="e-context-menu">
        <span class="far fa-ellipsis-v"></span>
    </button>
    <div id="e-context-menu" class="e-context-dropdown-content" role="menu">
        <ng-container *ngIf="menuOptions?.length">
            <a *ngFor="let option of menuOptions" (click)="onSelectMenuClick(option)" role="menuitem" context-menu-item>
                <span>{{ option.title }}</span>
            </a>
        </ng-container>
    </div>
</div>
